

import Vue from "vue";
import {DossierConfigService} from "@/services";
import AppLedgerAccountAutocomplete from "@/components/common/LedgerAccountAutocomplete.vue";
import AppSelectJournal from "@/components/SelectJournal.vue";
import { ISelectItem } from "winfakt-vue-components";
import { AuthService } from "@/services/auth-service";
import { MODULE } from "@/config/modules";

export default Vue.extend({
	data() {
		return {
			general: DossierConfigService.getGeneralConfig(),
			config: DossierConfigService.getBookkeepingConfig()
		};
	},
	computed: {
		hasFixedAssetsModule():boolean {
			return AuthService.isDevModeEnabled && AuthService.hasModule(MODULE.AFSCHRIJVINGSTABELLEN);
		},
		periodicityItems():ISelectItem<string>[] {
			return [
				{text: this.$ct("periodicity-month").toString(), value: "month"},
				{text: this.$ct("periodicity-year").toString(), value: "year"}
			];
		}
	},
	methods: {
		save(){
			DossierConfigService.setBookkeepingConfig(this.config);
			this.$wf.notify(this.$ct("common.saved"), "success", 3000, "check");
		}
	},
	components: {
		AppLedgerAccountAutocomplete,
		AppSelectJournal
	},
	i18nEx: {
		componentPrefix: "components.settings-default.default-central"
	}
});
